import { useEffect } from "react";
import { handlePageLoad } from "../utils/accessibility";
import { logPageView } from "../utils/analytics";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";


function About() {
  useEffect(() => {
    handlePageLoad();
    logPageView();
  }, []);

   const { t } = useTranslation();

return (
  <div className="aboutBackground nice_font dark_blue" >
    <div className="nice_font dark_blue">
      <div className="nice_font dark_blue" style={{"display":"flex","flexDirection":"column","flexGrow":"1","alignItems":"center","minHeight":"70dvh"}} >
        <div className="aboutColorado nice_font dark_blue" ><span className="nice_font dark_blue">{t("aboutColoradoLifts")}</span></div>
        <div className="flex-justify-right aboutTextBlock">
          <p className="aboutWhatIsParagraph dark_blue">
            {t("aboutParagraph1")}
          </p>
          <p className="markdown-container-about">
            <ReactMarkdown>
              {t("aboutParagraph2")}
            </ReactMarkdown>
          </p>
        </div>
      </div>
    </div>
  </div>
);
}

export default About;